export const LOCAL_VERSION = '1.0.21';
